export default __webpack_public_path__ + "static/media/b1.b13ab18a.JPG";